import { CannyChangelogOptions, CannyRenderOptions } from "@lifeat/shared/canny/CannyTypes";
import { functions } from "@firebase-local/firebase";
import { CANNY_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";

export function CannyService() {
    const appId = process.env.CANNY_APP_ID;

    async function generateToken() {
        const { data: token } = await functions.httpsCallable(CANNY_FUNCTIONS.GenerateCannyToken)();
        return token;
    }

    function renderEmbed(options: CannyRenderOptions) {
        if (!window.Canny) throw new MissingCannyError();
        window.Canny("render", options);
    }

    function initChangelog(options: CannyChangelogOptions) {
        if (!window.Canny) throw new MissingCannyError();
        window.Canny("initChangelog", {
            appID: appId,
            ...options,
        });
    }

    return { generateToken, renderEmbed, initChangelog };
}

export type CannyService = ReturnType<typeof CannyService>;

export class MissingCannyError extends Error {
    constructor() {
        super("Canny is not loaded");
    }
}
